module.exports = __webpack_public_path__ + "img/image_middle.eb05aa77.png";